import { getSvocId, getMemberId, getUserId } from '../utils/user';
var memberId = getMemberId();
var svocId = getSvocId();
var userId = getUserId();
export var B2C_ONE_ACCOUNT_PATH = '/b2b/user/account/b2c';
export var B2C_ACCOUNT_PATH = '/customer/account/v1';
export var B2B_ACCOUNT_PATH = '/b2b/user/account';
// B2C paths:
export var B2C_ACCOUNT_PATH_WITH_MEMBER_ID = "".concat(B2C_ONE_ACCOUNT_PATH, "/").concat(memberId);
export var B2C_ACCOUNT_PROFILE_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/profile?checkPhoneEligibility=true");
export var B2C_UPDATE_PROFILE_DATA_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/profile");
export var B2C_USER_ADDRESSES_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/addresses");
export var B2C_SECURITY_PAGE_PATH = '/account/ui/security';
export var B2C_EMAIL_OTP_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/getEmailOTP");
export var B2C_PHONE_OTP_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/getOldPhoneOTP");
export var B2C_PHONE_VERIFY_OTP_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/verifyOldPhoneOTP");
export var UPDATE_TO_PRO_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/profile/upgradeToPro?checkPhoneEligibility=true");
export var B2C_TRADE_TYPES_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/profile/tradeTypes");
export var B2C_EMAIL_VERIFY_OTP_PATH = "".concat(B2C_UPDATE_PROFILE_DATA_PATH, "/updateEmail");
export var B2C_CLOSE_ACCOUNT = '/myaccount/profile/closeAccount';
export var B2C_DEACTIVATE_ACCOUNT = "".concat(B2C_ONE_ACCOUNT_PATH, "/").concat(svocId, "/profile/closeAccount");
export var B2C_LOGOUT_ALL_ACCOUNTS = '/customer/auth/v1/logout/all';
export var B2C_ACCOUNT_PROFILE = '/myaccount/profile';
export var B2C_ACCOUNT_PREFERENCE = '/myaccount/preferences';
export var B2C_ACCOUNT_SECURITY = '/myaccount/security';
export var B2C_ACCOUNT_PRIVACY_SECURITY = '/privacy/privacy-and-security-statement';
// B2B paths:
export var B2B_ACCOUNT_PATH_WITH_USER_ID = "".concat(B2B_ACCOUNT_PATH, "/").concat(userId);
export var B2B_ACCOUNT_PROFILE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId, "/profile");
export var B2B_UPDATE_PROFILE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/profile");
export var B2B_TRADE_TYPES_PATH = "".concat(B2B_ACCOUNT_PATH, "/profile/tradetypes");
export var B2B_SECURITY_PAGE_PATH = '/myaccount/security';
export var B2B_HOMEPAGE_PATH = '/';
export var B2B_PROFILE_PREFERENCE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/profile/preferences");
export var B2B_MANAGE_USERS_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId, "/manageuser");
export var B2B_MANAGE_USERS_DELETE_PATH = "".concat(B2B_MANAGE_USERS_PATH, "/delete");
export var B2B_MANAGE_USERS_ADD_PATH = "".concat(B2B_ACCOUNT_PATH, "/").concat(userId, "/manageuser/add");
export var B2B_MANAGE_USERS_UPDATE_PATH = "".concat(B2B_ACCOUNT_PATH, "/").concat(userId, "/manageuser/update");
export var B2B_MANAGE_USERS_MULTI_DELETE_PATH = "".concat(B2B_MANAGE_USERS_PATH, "/bulkDelete");
export var B2B_MANAGE_USERS_RESEND_INVITE_PATH = "".concat(B2B_ACCOUNT_PATH, "/").concat(userId, "/manageuser/sendinvite");
export var B2B_MANAGE_USERS_MULTI_RESEND_INVITES_PATH = "".concat(B2B_MANAGE_USERS_PATH, "/multiResendInvite");
export var B2B_MANAGE_USERS_BULK_ADD_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/manageuser/bulkAdd");
export var B2B_MANAGE_GET_POLICY_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId, "/policy");
export var B2B_MANAGE_SAVE_POLICY_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId, "/savePolicy");
export var B2B_HOME_DEPOT_CREDIT_CARDS_PATH = '/b2b/account/view/thdcreditcard';
export var B2B_PROALLOWANCE_V2_PATH = "".concat(B2B_ACCOUNT_PATH, "/ra/pos/v2/").concat(svocId);
export var B2B_PRO_TRADE_CREDIT_RETRIEVE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId, "/payment/houseAccount/retrieve");
export var B2B_PRO_TRADE_CREDIT_RETRIEVE_BY_USER_PATH = function (authorizedUserId) {
    return "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId, "/authorized-user/").concat(authorizedUserId, "/payment/houseAccount/retrieve");
};
// Common paths:
export var USER_STORE_PATH = "/StoreSearchServices/v2/storesearch?storeid=";
export var ZIP_CODE_PATH = "".concat(B2B_ACCOUNT_PATH, "/zipCode");
export var UPGRADE_TO_PRO_PATH = '/c/professional_contractor';
export var TAX_EXEMPT_ID_PAGE_PATH = 'https://tax-exempt.homedepot.com/';
export var PRO_ALLOWANCE_PATH = '/myaccount/proallowance';
export var QUOTE_LIST_PATH = '/quote/list';
export var CREATE_PRO_LINKS = [
    {
        url: 'https://www.homedepot.com/c/PH_MyAccount',
        text: 'My Account Terms & Conditions',
    },
    {
        url: 'https://www.homedepot.com/c/Privacy_Security',
        text: 'Privacy & Security Statement',
    },
    {
        url: 'https://hdapps.homedepot.com/CustRecogServices/sec/rs/programservice/registrationGetProgramDocument?programId=7&documentType=TERMS',
        text: 'Pro Xtra Terms and Conditions',
    },
];
export var CUSTOMER_AUTH_API_PATH = '/customer/auth/v1/logout/all';
